import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';
import { CalendarRange, Trophy, Medal, Flame, ChevronRight, Coins, Scale } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GRADE_ICONS = { gold: Trophy, silver: Medal, bronze: Flame };
const GRADE_COLORS = { gold: 'text-amber-500', silver: 'text-slate-500', bronze: 'text-orange-600' };

export function WeeklySummaryCard() {
    const { language } = useLanguage();
    const de = language === 'de';
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        axios.get(`${API}/weekly/summary`, { params: { offset: 0, include_comment: false } })
            .then(res => setData(res.data))
            .catch(() => setData(null));
    }, []);

    if (!data?.has_data) return null;

    const GradeIcon = GRADE_ICONS[data.grade] || Medal;
    const delta = data.energy.week_delta;

    return (
        <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate('/weekly')} data-testid="weekly-summary-card">
            <CardContent className="p-4">
                <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                        <CalendarRange className="w-5 h-5 text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-1.5">
                            <span className="text-sm font-semibold">{de ? 'Nanouks Wochenrückblick' : "Nanouk's Weekly Review"}</span>
                            <GradeIcon className={`w-4 h-4 ${GRADE_COLORS[data.grade] || 'text-muted-foreground'}`} />
                            {data.streak?.weeks >= 2 && (
                                <span className="text-sm" data-testid="weekly-card-streak">
                                    {data.streak.medal === 'gold' ? '🥇' : data.streak.medal === 'silver' ? '🥈' : '🥉'} {data.streak.weeks}
                                </span>
                            )}
                        </div>
                        <div className="flex items-center gap-3 text-xs text-muted-foreground mt-0.5">
                            {data.taler.enabled && (
                                <span className="flex items-center gap-1">
                                    <Coins className="w-3 h-3 text-amber-600" />
                                    Ø {data.taler.avg_spent} {de ? 'Taler' : 'Taler'}
                                </span>
                            )}
                            <span className={`flex items-center gap-1 font-medium ${delta > 0 ? 'text-red-600' : 'text-green-600'}`}>
                                <Scale className="w-3 h-3" />
                                {delta > 0 ? '+' : ''}{Math.round(delta).toLocaleString('de-CH')} kcal
                            </span>
                        </div>
                    </div>
                    <ChevronRight className="w-5 h-5 text-muted-foreground shrink-0" />
                </div>
            </CardContent>
        </Card>
    );
}
